"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOrderLineConfigTitle = void 0;
const dayjs = require("dayjs");
const pluralize_1 = require("../pluralize");
const getOrderLineConfigTitle = (data, type) => {
    if (!data || !type)
        return null;
    switch (type) {
        case "GOLF": {
            const config = data;
            if (!config?.product?.config?.holes)
                return `Golf at ${config?.course?.name?.en}`;
            return `${config?.product?.config?.holes} Holes at ${config?.course?.name?.en}`;
        }
        case "HOTEL": {
            const config = data;
            return `Check-in at ${config.where_when_who.hotel?.name?.en} (${(0, pluralize_1.pluralize)(config.where_when_who.number_of_nights, "Night", "Nights")})`;
        }
        case "EXCURSION": {
            const config = data;
            return `${config?.product?.excursion?.name?.en}`;
        }
        case "TRANSFER": {
            const config = data;
            // const custom = config?.vehicle?.rate?.type === "CUSTOM" ? " (Custom)" : "";
            switch (config.where_when_who.type) {
                case "ONE_WAY":
                case "RETURN":
                    return `${config?.transfer_legs?.outbound?.from_name} > ${config?.transfer_legs?.outbound?.to_name} `;
                case "CUSTOM":
                    return `${config?.transfer_legs?.outbound?.from_name} > ${config?.transfer_legs?.outbound?.to_name} > ${config?.transfer_legs?.inbound?.to_name}`;
            }
            return "";
        }
        case "CUSTOM": {
            const config = data;
            if (config?.where_when_who?.type === "EXTRA") {
                return `${config.where_when_who.title} (${dayjs(config.where_when_who.date).format("ddd, Do MMM")}${config?.where_when_who?.duration > 1
                    ? ` - ${dayjs(config.where_when_who.date)
                        .add(config.where_when_who.duration, "day")
                        .format("ddd, Do MMM")}`
                    : ""})`;
            }
            return config.where_when_who.title;
        }
    }
};
exports.getOrderLineConfigTitle = getOrderLineConfigTitle;
